import React from "react";
import { Plus } from "lucide-react";
import Breadcrumb from "./breadcrumb";
import Button from "./button";

const PageHeader = ({
  title,
  subtitle,
  buttonText,
  onButtonClick,
  buttonProps = {},
  renderButtons,
  disabled = false,
}) => {
  return (
    <div className="flex flex-col mb-2 sm:flex-row justify-between items-start sm:items-center gap-4">
      <div>
        <Breadcrumb />
      </div>

      {renderButtons ? (
        <div className="flex gap-2">{renderButtons()}</div>
      ) : (
        buttonText && (
          <Button
            onClick={onButtonClick}
            disabled={disabled}
            {...buttonProps}
          >
            <Plus className="w-4 h-4 mr-2" />
            {buttonText}
          </Button>
        )
      )}
    </div>
  );
};

export default PageHeader;
